<script>
import appConfig from "@/app.config";
import { UAParser } from 'ua-parser-js';
import { userMethods, configComputed, userComputed, configMethods, categoryComputed, categoryMethod, departmentComputed, departmentMethod } from "@/state/helpers";
import { mixin } from "@/helpers/Vue-Mixin";
import { filter } from "@/helpers/Vue-Filter";
import Loader from "../../components/widgets/loader.vue";
import api from "@/api/";
import Add from "./add.vue";
import Edit from "./edit.vue";
import Multiselect from "vue-multiselect";
import Pagination from "../../components/widgets/pagination.vue";
import moment from 'moment';

const PageHeader = () => import(/* webpackChunkName: "PageHeader" */ "@/components/page-header");
const Layout = () => import(/* webpackChunkName: "Layout" */ "../../router/layouts/main.vue");

export default {
  /* eslint-disable no-console */
  mixins: [mixin],

  filters: {
    ...filter,
  },

  page: {
    title: "アカウント一覧 (登録)",
    meta: [{ name: "description", content: appConfig.description }],
  },

  // eslint-disable-next-line vue/no-unused-components
  components: {
    Layout,
    PageHeader,
    Loader,
    Add,
    Edit,
    Multiselect,
    Pagination
  },

  watch: {
    gPagination: {
      handler(value) {
        this.paginationPages = value.last_page;
      },
      deep: true,
    },
  },

  data() {
    return {
      items: [
        {
          text: "アカウント一覧 (登録)",
          href: "/admin/operators",
          active: true,
        },
      ],
      search: {},
      loading: false,
      paginationPages: 5,
      page: 1,
      dataInsert: {},
      dataUpdate: {},
      sortBy: "age",
      sortDesc: false,
      excelIds: [],
      keySort: "created_at",
      typeSort: 0,
      types: ["desc", "asc"],

      isAll: false,
      ignoreIds: [],
      isFlagShowModalAdd: false,
      isFlagShowModalEdit: false,
      dataEdit: {
        mobile:'',
        facility_id: '',
        department_id: '',
        category: [],
        information: {
          fullname: '',
          creator_name: '',
          category_name: '',
        },
        role: 'hospital',
        facility: {
          id: '',
          name: '',
          code: ''
        }
      },
      role: 'hospital',
      dataFacility: {},
      facilityNames:[],
      isFilterOpen: false,
      lastLoadedTime: null,
      optionCategories: [],
      optionDepartments: [],
    };
  },

  created() {
    try {
      this.loading = true;
      this.getACountUser(this.role);
      this.getConfig();
      this.fetch({
        role: this.role,
      }).then((e) => {
        if (e.status === 200) {
          this.loading = false;
        }
      });
      this.pagination = Object.assign(this.gPagination, {});
      this.listFacility()
    } catch (error) {
      console.log(error);
    }
    const formattedDate = moment().format('YYYY/MM/DD HH:mm:ss');
    localStorage.setItem('lastLoadedTime', formattedDate);
    this.lastLoadedTime = localStorage.getItem('lastLoadedTime');
  },

  async mounted() {
    await this.listCategories({ page: 1 });
    await this.listDepartments({ page: 1 });

    if (this.gCategories && this.gPaginationCategory) {
      this.optionCategories = this.gCategories.map(category => (category.name));

      if (this.optionCategories.length > 0) {
        this.optionCategories.shift();
      }

      if (this.gPaginationCategory.current_page < this.gPaginationCategory.last_page) {
        this.listCategories({ page: this.gPaginationCategory.current_page + 1 }).then((e) => {
          if (e.status === 200) {
            this.optionCategories = [...this.optionCategories, ...e.data.data.map(data => data.name)];
          }
        });
      }
    }

    if (this.gDepartments && this.gPaginationDepartments) {
      this.optionDepartments = this.gDepartments.map(category => (category.name));

      if (this.optionDepartments.length > 0) {
        this.optionDepartments.shift();
      }

      if (this.gPaginationDepartments.current_page < this.gPaginationDepartments.last_page) {
        this.listDepartments({ page: this.gPaginationDepartments.current_page + 1 }).then((e) => {
          if (e.status === 200) {
            this.optionDepartments = [...this.optionDepartments, ...e.data.data.map(data => data.name)];
          }
        });
      }
    }
  },

  computed: {
    ...userComputed,
    ...configComputed,
    ...categoryComputed,
    ...departmentComputed,

    theme() {
      return this.$store.state.theme;
    },

    fields() {
      return [
        { key: "#", class: "text-center align-middle p-3 tilte-column" },
        {
          key: "facility_name",
          label: '施設名',
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "information.fullname",
          label: '担当者名',
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "mobile",
          label: '携帯番号',
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "category_name",
          label: '施設区分',
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "department_name",
          label: '部門',
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "status",
          label: "操作",
          class: "text-center align-middle tilte-column" ,
          height: "50px",
        }
      ];
    },
  },

  methods: {
    ...userMethods,
    ...configMethods,
    ...categoryMethod,
    ...departmentMethod,

    listFacility(){
      api.getListNameFacility().then((e) =>{
        if (e.status === 200) {
          this.facilityNames = e.data.map(facility => facility.name);
        }
      });
    },

    toastSuccess() {
      window.toastr.success("作成に成功しました");
    },

    toastSuccessEdit() {
      window.toastr.success("編集に成功しました");
    },

    changeSelected() {
      document.onkeyup = (e) => {
        if (e.keyCode === 13) {
          this.onFilter();
        }
      };
    },

    isChecked(id) {
      return (
        (this.isAll && !this.ignoreIds.includes(id)) ||
        this.excelIds.includes(id)
      );
    },

    isCheckedAll() {
      if (this.gUsers.length > 0) {
        return (
          (this.isAll && this.ignoreIds.length === 0) ||
          this.excelIds.length === this.gPagination.total
        );
      }

      return false;
    },

    checkAll() {
      if (this.ignoreIds.length > 0) {
        this.ignoreIds = [];
      } else {
        this.isAll = !this.isAll;
        if (!this.isAll) {
          this.excelIds = [];
        }
      }
    },

    activeExport() {
      if (this.gUsers.length > 0) {
        return !this.isAll && this.excelIds.length === 0;
      }

      return true;
    },

    removeUser(id) {
      this.confirm(
        {
          title: "",
          text: "削除しますか?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#395299",
          cancelButtonColor: "#FF5858",
          confirmButtonText: "はい",
          cancelButtonText: "いいえ",
        },
        async (e) => {
          if (e.isConfirmed) {
            const res = await api.deleteUsers({ids: id, role: this.role});
            if (res.status == 200) {
              window.toastr.success("削除に成功しました");
              await this.onSearch();
              this.getACountUser(this.role);
              this.excelIds = [];
            } else {
              window.toastr.error("削除に失敗しました");
            }
          }
        }
      );
    },

    removeDevice(user) {
      if (!user.browser) {
        return;
      }

      const device = user.browser;
      const {browser, os} = UAParser(device.agent);

      this.confirm(
        {
          title: "デバイス情報",
          html: `
            <div class="fs-6">
              ${browser.name} ${browser.major}<br>
              ${os.name} ${os.version}<br>
              IP: ${device.ip}
            </div>
          `,
          showCancelButton: true,
          confirmButtonColor: "#FF5858",
          cancelButtonColor: "#6e6e6e",
          confirmButtonText: "取り除く",
          cancelButtonText: " キャンセル ",
        },
        async (e) => {
          if (e.isConfirmed) {
            const res = await api.removeDevice(device.user_id);
            if (res.status === 200) {
              user.browser = null;
              window.toastr.success("削除されたデバイス情報");
            } else {
              window.toastr.error("機器情報の削除に失敗しました");
            }
          }
        }
      );
    },

    async doAction(type) {
      if (!this.isAll && this.excelIds.length === 0) {
        window.toastr.error("施設管理者を選択してください");
      } else {
        try {
          let payload = {
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          };
          if (this.isAll) {
            if (this.search.age !== undefined && this.search.age !== "") {
              payload.age = this.search.age;
            }
            if (
              this.search.birthday !== undefined &&
              this.search.birthday !== ""
            ) {
              payload.birthday = filter.fomatDate(
                this.search.birthday,
                "YYYY/MM/DD"
              );
            }
            if (
              this.search.fullname !== undefined &&
              this.search.fullname !== ""
            ) {
              payload.fullname = this.search.fullname;
            }
            if (
              this.search.patient_id !== undefined &&
              this.search.patient_id !== ""
            ) {
              payload.patient_id = this.search.patient_id;
            }
            if (this.search.status !== undefined && this.search.status) {
              payload.status = this.search.status.value;
            }
            if (this.search.facilities !== undefined && this.search.facilities) {
              payload.facilities = [{name: this.facilitiesName,},];
            }
            if (this.search.sex !== undefined && this.search.sex) {
              payload.sex = this.search.sex.value;
            }
            if (this.ignoreIds.length > 0) {
              payload.ignore_ids = this.ignoreIds.toString();
            }
          } else {
            payload.ids = this.excelIds.toString();
          }
          payload.role = this.role;

          const response =
            type === "excel"
              ? api.exportExcelUser(payload)
              : api.deleteUsers(payload);
          this.initExport();

          return response;
        } catch (error) {
          console.log(error);
        }
      }
    },

    chooseItem(id) {
      if (this.isAll) {
        this.ignoreIds = this.setArray(this.ignoreIds, id);
        if (this.ignoreIds.length === this.gPagination.total) {
          this.isAll = false;
          this.ignoreIds = [];
        }
      } else {
        this.excelIds = this.setArray(this.excelIds, id);
        if (this.excelIds.length === this.gPagination.total) {
          this.isAll = true;
          this.excelIds = [];
        }
      }
    },

    setArray(array, id) {
      const index = array ? array.findIndex((element) => element === id) : -1;
      index >= 0 ? array.splice(index, 1) : array.push(id);

      return array;
    },

    async onSearch(page = 1) {
      try {
        this.loading = true;
        this.page = page < 1 ? 1 : page;
        await this.fetch(
          Object.assign(this.search, {
            role: this.role,
            page: this.page,
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          })
        ).then((e) => {
          if (e.status == 200) {
            this.loading = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    async onFilter() {
      this.getACountUser(this.role);
      this.initExport();
      await this.onSearch();
    },

    async onClear() {
      this.search = {};
      this.initExport();
      await this.onSearch();
    },

    initExport() {
      this.isAll = false;
      this.ignoreIds = [];
      this.excelIds = [];
    },

    onSort(key) {
      if (key === this.keySort) {
        this.typeSort = Math.abs(this.typeSort - 1);
      } else {
        this.keySort = key;
        this.typeSort = 0;
      }

      this.onSearch();
    },

    async onPagination(page) {
      try {
        this.loader = true;
        await this.onSearch(page);
      } catch (error) {
        console.log(error);
      }
    },

    async handlerSubmit() {
      try {
        await this.post(this.dataInsert);
        this.alertSuccess();
      } catch (error) {
        this.alertError();
        console.log(error);
      }
    },

    async handlerEdit(id) {
      try {
        this.isFlagShowModalEdit = true;
        this.dataEdit = this.gUsers.find(item => item.id === id);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    },

    async closeModal() {
      this.isFlagShowModalAdd = false;
      this.isFlagShowModalEdit = false;
    },

    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
    },

    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<template>
  <div id="admin">
  <Layout class="kurua-page">
    <div class="col-12 d-flex justify-content-between align-items-center  mb-xl-0 mt-lg-n3 mb-lg-2 mt-md-n3 mb-md-2">
      <div class="d-flex align-items-center justify-content-start mt-xl-2 mt-md-n4">
        <PageHeader :items="items" fontSize="28px" fontWeight="700 !important" margin-top="6px !important" title="可動域評価"/>
        <div class=" d-flex reload-button" style="margin-left: 18rem">
          <button @click="reloadPage" class="custom-button">
            <img src="@/assets/images/icon/icon-reload.svg" alt="" style="width: 20px; height: 20px;" />
            更新
          </button>
          <div class="ml-1">
            <p style="margin: 0; padding-left: 10px; font-size: 14px;">最終更新日時:</p>
            <p style="margin: 0; padding-left: 10px; font-size: 14px; margin-top: -5px;">{{ lastLoadedTime }}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-6 pb-3">
        <div class="row">
          <div class="col-4">
            <b-button class="btn btn-outline-lyg-new w-100 px-2"
              style="background-color: white; border: 1px solid #395299; color: #395299 !important;"
              @click="toggleFilter()">
              <img src="@/assets/images/icon/icon-filter.svg" alt="" style="width: 20px; height: 20px;" />
              絞り込み
            </b-button>
          </div>
          <div class="col-4">
            <b-button :disabled="activeExport()" :class="{'bg-disabled': activeExport()}"
              class="btn-lyg w-100 px-1" @click="doAction('excel')">
              <img
                :src="!activeExport() ? require('@/assets/images/icon/icon-export-white.svg') : require('@/assets/images/icon/icon-export.svg')"
                alt="" style="width: 20px; height: 20px;" />
              Excel出力
            </b-button>
          </div>
          <div class="col-4">
            <b-button class="btn btn-lyg-new w-100 text-button btn-secondary px-0" @click="isFlagShowModalAdd = true">アカウント登録</b-button>
          </div>
        </div>
      </div>
    </div>
    <Add lazy @successInsert="toastSuccess(), onSearch()" @closeModal="closeModal" :isShow="isFlagShowModalAdd" />
    <Edit lazy @successInsert="toastSuccessEdit(), onSearch()" @closeModal="closeModal" :isShowEdit="isFlagShowModalEdit" :data="dataEdit" />
    <div class="card" v-if="isFilterOpen">
      <div class="col-12 p-4">
        <h5 class="text-label-filter">{{ $t("menuitems.hospital.filter") }}</h5>
        <hr />
        <form action="" @submit.prevent="onFilter">
          <div class="row">
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" label="施設名" label-for="施設名">
                <multiselect style="z-index: 1040;" v-model="search.facility_name" :options="facilityNames || []" placeholder="所属施設を入力してください。" id="code"
                  class="helo" :multiple="false" :show-labels="false">
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" label="担当者名" label-for="担当者名">
                <b-form-input class="helo" v-model="search.fullname" placeholder="担当者名を入力してください。" for="担当者名" type="search" :maxlength="256"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" label="携帯番号" label-for="携帯番号">
                <b-form-input v-model="search.mobile" placeholder="携帯番号を入力してください。" for="携帯番号" :maxlength="256" value="" class="helo" type="search"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" label="施設区分" label-for="施設区分">
                <multiselect style="z-index: 1039;" v-model="search.category_name" :options="optionCategories || []" placeholder="施設区分を入力してください。" id="code"
                  class="helo" :multiple="false" :show-labels="false">
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" label="部門" label-for="部門">
                <multiselect style="z-index: 1038;" v-model="search.department_name" :options="optionDepartments || []" placeholder="部門を入力してください。" id="code"
                  class="helo" :multiple="false" :show-labels="false">
                </multiselect>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4 text-white">
              <div class="row">
                <div class="col-6">
                  <b-form-group label="0000">
                    <b-button type="submit" class="btn-lyg-new w-100 pl-1 pr-1 text-button">
                      {{ $t("menuitems.hospital.search") }}
                    </b-button>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group label="0000">
                    <button class="btn btn-outline-lyg-new w-100 text-button btn-clear-filter-new" @click="onClear()">
                      クリア
                    </button>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="mb-0" :style="{minHeight: isFilterOpen ? '50vh' : '80vh'}">
      <Loader theme="plus" :loading="loading">
        <div class="col-12">
          <b-table :items="gUsers || []" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" sort-icon-left hover outlined thead-class="sticky-top text-center bg-table-lyg" sticky-header :style="{ maxHeight: isFilterOpen ? '44vh' : '75vh' }" responsive="sm">
            <template #head(#)>
              <b-form-checkbox id="checkbox-all" @change="checkAll()" name="checkbox-all" :checked="isCheckedAll()"></b-form-checkbox>
            </template>
            <template #head()="{ label, field: { key, sortable } }">
              {{ label }}
              <template v-if="sortable">
                <!-- Custom icons -->
                <template>
                  <span v-if="sortBy !== key">
                    <i class="mdi mdi-sort-bool-ascending"></i>
                  </span>
                  <span v-else-if="sortDesc">
                    <i class="mdi mdi-sort-bool-descending"></i>
                  </span>
                  <span v-else>
                    <i class="mdi mdi-sort"></i>
                  </span>
                </template>
              </template>
            </template>
            <template #cell(#)="row">
              <b-form-checkbox id="checkbox-1" @change="chooseItem(row.item.id)" name="checkbox-1" :checked="isChecked(row.item.id)"></b-form-checkbox>
            </template>
            <template #cell(mobile)="row">
              {{ row.item.mobile }}
            </template>
            <template #cell(category_name)="row">
              {{ row.item.category ? row.item.category[0]?.name : '' }}
            </template>
            <template #cell(facility_name)="row">
              {{ row.item.facility ? row.item.facility.name : '' }}
            </template>
            <template #cell(department_name)="row">
              {{ row.item.department ? row.item.department.name : '' }}
            </template>
            <template slot="selected" slot-scope="data">
              <b-form-checkbox @click.native.stop :value="data.item.schoolId" :checked="allSelected"></b-form-checkbox>
              {{ data.index }}
            </template>
            <template #cell(status)="row">
              <ul class="list-inline font-size-20 contact-links mb-0">
                <li title="デバイス情報" @click=removeDevice(row.item) class="list-inline-item px-2 icon-large">
                  <a>
                    <i class="bx bx-devices text-white p-1"
                      :class="row.item.browser ? 'bg-icon pointer' : 'bg-disabled'"
                      style="border-radius: 50%"></i>
                  </a>
                </li>
                <li title="編集" @click=handlerEdit(row.item.id) :showEdit="true" class="list-inline-item px-2 icon-large">
                  <a>
                    <img src="@/assets/images/icon/icon-changes.svg" alt="" style="width: 28px; height: 28px; margin-top: -0.5rem; cursor: pointer;" />
                  </a>
                </li>
                <li title="削除" @click="removeUser(row.item.id)" class="list-inline-item px-2 icon-small">
                  <a>
                    <i class="bx bx-trash text-white bg-danger p-1 pointer" style="border-radius: 50%;"></i>
                  </a>
                </li>
              </ul>
            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-if="gUsers.length === 0">
          <div class="undefine">
            <img src="@/assets/images/no-data.jpg" alt="" />
            <div class="mt-3">詳細データはありません。</div>
          </div>
        </div>
        <Pagination :paging="gPagination" @change="onPagination" label="アカウント数：" unitLabel="件"/>
      </Loader>
    </div>
  </Layout>
  </div>
</template>

<style lang="scss" scoped>
::v-deep th {
  text-align: center !important;
}
</style>